export const LOCK_IT_IN_CABINS = [
  'GTY', // Guarantee
];

export const ADDON_TYPES = {
  VOYAGE_PROTECTION: 'VOYAGE_PROTECTION',
  VOYAGE_PROTECTION_SINGLE_SAILOR_INFO_WARNING: 'VOYAGE_PROTECTION_SINGLE_SAILOR_INFO_WARNING',
} as const;

export const ADDON_STATE_CHANGE_SOURCE = {
  CARD: 'CARD',
  FLYOUT: 'FLYOUT',
} as const;

export const VIRGIN_RED_USER_CONSENTS = {
  dataSharing: 'Data Sharing',
  groupMarketing: 'Group Marketing Consent',
};

export const VIRGIN_RED_USER_CONSENTS_STATES = {
  CONFIRMED: 'CONFIRMED',
  WITHDRAWN: 'WITHDRAWN',
};
